<div class="w-full flex justify-center px-6 sm:px-10">
  <div class="w-full max-w-[900px] flex flex-col gap-20 mt-20">

    <ng-container *ngFor="let item of items; let i = index">
      <ng-container *ngIf="item.type !== 'conclusion'">
        <div class="flex flex-col sm:flex-row items-center gap-10" [ngClass]="{ 'sm:flex-row-reverse': i % 2 === 1 }">
          <img class="object-contain max-h-[110px] sm:max-h-[150px] flex-shrink-0 mx-auto sm:mx-0"
               [src]="'images/shared/steps/0' + (i + 1) + '.png'"
               [alt]="'Step ' + (i + 1)" />

          <div class="flex-1 text-white leading-relaxed max-w-[650px] mx-auto sm:mx-0 px-2">
            <h2 class="text-2xl font-semibold mb-4 text-center sm:text-left font-outfit">
              <ng-container *ngIf="formatTitle(item.title).single; else multiTitle">
                <span class="gradient-text">{{ formatTitle(item.title).rest }}</span>
              </ng-container>
              <ng-template #multiTitle>
                <span class="text-white">{{ formatTitle(item.title).first }}</span>
                <span *ngIf="formatTitle(item.title).rest" class="gradient-text">{{ formatTitle(item.title).rest }}</span>
              </ng-template>
            </h2>

            <p *ngIf="item.type === 'text'" class="text-center sm:text-left">{{ item.content }}</p>

            <ul *ngIf="item.type === 'bullets'" class="list-disc ml-6 space-y-2">
              <li *ngFor="let bullet of (item.content || '').split(',')">{{ bullet.trim() }}</li>
            </ul>

            <div *ngIf="item.type === 'list'" class="space-y-3">
              <div *ngFor="let line of getFormattedLines(item.content)">
                <span class="font-semibold">{{ line.first }} - </span>
                <span>{{ line.second }}</span>
              </div>
            </div>

            <ng-container *ngIf="item.type === 'titleBullets'">
              <ng-container *ngFor="let group of item.nestedBullets">
                <h4 class="text-lg font-medium mb-1">{{ group.subtitle }}</h4>
                <ul class="list-disc ml-6 mb-4">
                  <li *ngFor="let bullet of group.bullets">{{ bullet }}</li>
                </ul>
              </ng-container>
            </ng-container>

          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngFor="let item of items">
      <ng-container *ngIf="item.type === 'conclusion'">
        <div class="w-full mt-20">
          <h2 class="text-2xl font-semibold mb-4 font-outfit gradient-text text-left inline-block">Conclusion</h2>
          <p class="text-white leading-relaxed mx-auto sm:mx-0 text-left">{{ item.content }}</p>
        </div>
      </ng-container>
    </ng-container>

  </div>
</div>
